module.exports = __webpack_public_path__ + "static/media/TOMB-FTM.84532366.png";